import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import {
  UiAppHeaderComponent,
  UiProfileMenuItem,
} from '../../organisms/app-header/app-header.component';
import {
  UiAppSidebarComponent,
  UiAppSidebarItem,
} from '../../organisms/app-sidebar/app-sidebar.component';
import {
  UiMenubarComponent,
  UiMenubarItem,
} from '../../organisms/menubar/menubar.component';
import {
  UiTitleBarComponent,
  UiTitleBarMode,
} from '../../organisms/title-bar/title-bar.component';
import { UiBreadcrumbItem } from '../../atoms/breadcrumb/breadcrumb.component';

export type { UiAppSidebarItem, UiMenubarItem };

/**
 * Template: shell independiente para la pantalla de bienvenida.
 *
 * Mantiene la misma jerarquía visual base de App Layout (header, sidebar,
 * menubar, title bar y contenido), pero conserva implementación y contrato
 * propios para que ambos templates puedan evolucionar por separado.
 * No contiene lógica de negocio ni depende de servicios de dominio.
 */
@Component({
  selector: 'ui-welcome-panel',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    UiAppHeaderComponent,
    UiAppSidebarComponent,
    UiMenubarComponent,
    UiTitleBarComponent,
  ],
  templateUrl: './welcome-panel.component.html',
  styleUrl: './welcome-panel.component.scss',
  host: {
    class: 'ui-welcome-panel-host',
  },
})
export class UiWelcomePanelComponent {
  readonly logoSrc = input<string | null>(null);
  readonly logoAlt = input('');
  readonly navTitle = input<string | null>(null);
  readonly showHome = input(false);
  /** Muestra el slot derecho del Header, inmediatamente antes de su toolbar. */
  readonly showHeaderSelector = input(false);
  readonly notificationCount = input<number | null>(null);
  readonly messageCount = input<number | null>(null);
  /** `null` conserva el default del header: visible solo en portal. */
  readonly showMessages = input<boolean | null>(null);
  readonly userAvatarLabel = input<string | null>(null);
  readonly profileUserName = input('');
  readonly profileUserRole = input('');
  readonly profileUserEmail = input('');
  readonly profileMenuItems =
    input<readonly UiProfileMenuItem[] | undefined>(undefined);

  readonly sidebarItems = input<readonly UiAppSidebarItem[]>([]);
  readonly sidebarSelectedValue = input<string | null>(null);
  readonly sidebarCollapsed = input(false);
  readonly sidebarAriaLabel = input('Sistemas disponibles');

  readonly showMenubar = input(true);
  readonly menubarItems = input<readonly UiMenubarItem[]>([]);
  readonly menubarAriaLabel = input('Menú principal');

  readonly showTitleBar = input(true);
  readonly title = input('');
  readonly titleBarMode = input<UiTitleBarMode>('control-panel');
  readonly breadcrumbItems = input<readonly UiBreadcrumbItem[]>([]);
  readonly breadcrumbHome = input<UiBreadcrumbItem | null>(null);
  readonly breadcrumbAriaLabel = input('Ruta de navegación');
  readonly mainLabel = input('Contenido de bienvenida');

  readonly sidebarToggle = output<void>();
  readonly sidebarItemSelect = output<string>();
  readonly menubarItemSelect =
    output<{ id: string; item: UiMenubarItem }>();
  readonly homeClick = output<void>();
  readonly logoutClick = output<void>();
}
